// src/SceneLoader.ts
// 3dobjsel.json をローカルから読み込んで、Matterport SDK のシーンとして復元する
// サンプル依存を避けたシンプル実装

import type { MpSdk } from '@mp/bundle-sdk/sdk';
import sceneJson from '../assets/3dobjsel.json';

// 自前のローカルシーンID → JSON データの対応表
// ★ ここで byRyoMatsuo を使う
const LOCAL_SCENES: Record<string, any> = {
  byRyoMatsuo: sceneJson,
};

export type SceneNodeVisitor = (node: MpSdk.Scene.INode) => void;

export class SceneLoader {
  private sdk: MpSdk;

  constructor(sdk: MpSdk) {
    this.sdk = sdk;
  }

  /**
   * ローカル JSON シーンを読み込み、各ノードに対して visitor を一度ずつ呼び出す。
   * 最後にシーンを start() して IObject を返す。
   */
  async load(sid: string, visitor?: SceneNodeVisitor): Promise<MpSdk.Scene.IObject> {
    const data = LOCAL_SCENES[sid];
    if (!data) {
      throw new Error(`Unknown local scene id: ${sid}`);
    }

    // JSON からシーンオブジェクトを生成
    const sceneObject = await this.sdk.Scene.deserialize(JSON.stringify(data));
    const anyScene: any = sceneObject;

    // SDK のバージョンによって getNodes / nodeIterator のどちらかを使う
    let nodes: MpSdk.Scene.INode[] = [];
    if (typeof anyScene.getNodes === 'function') {
      nodes = anyScene.getNodes();
    } else if (typeof anyScene.nodeIterator === 'function') {
      nodes = Array.from(anyScene.nodeIterator());
    }

    if (visitor) {
      for (const node of nodes) {
        visitor(node);
      }
    }

    if (typeof anyScene.start === 'function') {
      anyScene.start();
    }

    return sceneObject;
  }
}
